import { createTheme } from '@mui/material/styles'

const theme = createTheme({
  palette: {
    primary: {
      main: '#0b5fff'
    },
    secondary: {
      main: '#00a86b'
    }
  },
  typography: {
    h3: {
      fontWeight: 700
    }
  }
})

export default theme
